<template>
  <div>
    <section class="search-results-mobile">
      <div class="search-results-mobile--vehicle-data my-4 py-3">
        <div class="container">
          <div class="row">
            <div class="col search-results-mobile--data">
              <div class="brand">
                <div class="icon">
                  <span class="of-sprite van"></span>
                </div>
                <p>{{results[0].make}}</p>
              </div>
              <div class="model">
                <div class="icon">
                  <span class="of-sprite car"></span>
                </div>
                <p>{{results[0].model}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(result, i) in results" :key="i"
            class="search-results-mobile--info mb-3">
        <div v-b-toggle="`collapse-result-mobile-${i}`" class="container py-3">
          <div class="row">
            <div class="col">
              <div class="d-flex justify-content-between align-items-center">
                <div class="search-results-mobile--data">
                  <div class="engine mb-3">
                    <div class="icon">
                      <span class="of-sprite engine"></span>
                    </div>
                    <p>{{result.engine_version}}</p>
                  </div>
                  <div class="from mb-2">
                    <div class="icon">
                      <span class="of-sprite calender"></span>
                    </div>
                    <p>{{result.manufactured_from}}</p>
                  </div>
                  <div class="fuel-type mb-2">
                    <div class="icon">
                      <span class="fuel-type-icon"></span>
                    </div>
                    <p>{{result.fuel_type | formatFuelType}}</p>
                  </div>
                  <div class="info">
                    <div class="icon">
                      <span class="of-sprite i"></span>
                    </div>
                    <p>{{result.info ? result.info : '-'}}</p>
                  </div>
                </div>
                <div class="collapse-icon">
                  <img src="@/assets/icons/arrow-secondary.svg" class="arrow">
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-collapse :id="`collapse-result-mobile-${i}`" visible>
          <div class="container pb-3">
            <div class="row">
              <div class="col">
                <div class="refrigerant search-group">
                  <div class="search-results-mobile--data">
                    <div class="gas py-2">
                      <div class="icon">
                        <span class="of-sprite cooling"></span>
                      </div>
                      <p>{{result.gas}}</p>
                    </div>
                    <div class="ref py-2">
                      <div class="icon">
                        <span class="of-sprite gr"></span>
                      </div>
                      <p>{{result.refrigerant_quantity}}</p>
                    </div>
                    <div class="tolerance py-2">
                      <div class="icon">
                        <span class="of-sprite plus-minus"></span>
                      </div>
                      <p>{{result.refrigerant_quantity_tolerance}}</p>
                    </div>
                  </div>
                </div>
                <div class="lubricant search-group">
                  <div class="search-results-mobile--data">
                    <div class="oil py-2">
                      <div class="icon">
                        <span class="of-sprite oil"></span>
                      </div>
                      <p>{{result.oil}}</p>
                    </div>
                    <div class="oil-quantity py-2">
                      <div class="icon">
                        <span class="of-sprite ml"></span>
                      </div>
                      <p>{{result.oil_quantity}}</p>
                    </div>
                  </div>
                </div>
                <div class="mt-3">
                  <b-icon v-b-modal="`modal-send-mobile-${result.id}`" icon="envelope" class="text-xl text-secondary pointer"></b-icon>
                  <b-modal :id="`modal-send-mobile-${result.id}`" :title="$t('forms.send')" title-class="bold text-md" hide-footer>
                    <OilGasFinderSendForm :oilId="result.id" />
                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </section>
  </div>
</template>
<script>
import OilGasFinderSendForm from '@/components/oil-gas-finder/OilGasFinderSendForm.vue';
import FormatFuelType from '@/filters/FormatFuelType';

export default {
  components: {
    OilGasFinderSendForm,
  },
  props: {
    results: null,
  },
  filters: {
    FormatFuelType,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.search-results-mobile {
  display: none;
  &--vehicle-data {
    background-color: $light-grey;
  }
  &--data {
    > div {
      display: flex;
      align-items: center;
      .icon {
        width: 100px;
        display: flex;
        align-items: center;
      }
      > p {
        @extend .text-xs;
        margin: 0;
        font-weight: bold;
      }
    }
  }
  &--info {
    background-color: $light-grey;
    .collapse-icon {
      padding: 5px;
      img {
        max-width: 18px;
        transform: rotate(90deg);
        transition: transform .3s ease-in-out;
      }
    }
    .search-group {
      padding: 10px 15px;
      border-radius: 0 0 10px 10px;
      &.refrigerant {
        background-color: #d7eefa;
        background-image: linear-gradient(to bottom, #edf2f6 0%, #d7eefa 100%);
        margin-bottom: 15px;
      }
      &.lubricant {
        background-color: #e5d4dc;
        background-image: linear-gradient(to bottom, #edf2f6 0%, #e5d4dc 100%);
      }
    }
  }
  @include media-breakpoint-down (md) {
    display: block;
  }
}
.collapse-icon {
  padding: 5px;
  img {
    max-width: 18px;
    transform: rotate(90deg);
    transition: transform .3s ease-in-out;
  }
}
.not-collapsed {
  .collapse-icon img {
    transform: rotate(-90deg)!important;
  }
}
</style>
